import type { HttpClient } from '~/api/client';
import { httpClient } from '~/api/client';
import type { ProductInquiry, ProductInquiryPage } from '~/api/model';

// Response 타입 (Zod Model 재사용 — OAISchema 금지, api-typegen §0)
type ProductInquiryItem = ProductInquiry;
export type ProductInquiryPageResponse = ProductInquiryPage;

// Request DTO 직접 정의 (OAISchema 금지 — §0)
export type ProductInquiryRequest = {
  /** 상품 문의 내용 */
  content: string;
  /** 비밀글 여부 */
  isSecret?: boolean;
  secret?: boolean;
  /** 상품(OFFER) ID */
  offerId: number;
  /** 상품 문의 타입 */
  type: 'PRODUCT' | 'DELIVERY' | 'RESTOCK' | 'ETC';
};

export interface InquiryDataSource {
  // Query
  getMyInquiries(params?: {
    lastInquiryId?: number;
    size?: number;
  }): Promise<ProductInquiryPageResponse>;
  getMyInquiryCount(): Promise<number>;

  // Mutation
  editInquiry(
    inquiryId: number,
    data: ProductInquiryRequest,
  ): Promise<ProductInquiryItem>;
  deleteInquiry(inquiryId: number): Promise<ProductInquiryItem>;
}

export class InquiryDataSourceImpl implements InquiryDataSource {
  // eslint-disable-next-line no-useless-constructor
  constructor(private readonly client: HttpClient = httpClient) {}

  async getMyInquiries(params?: { lastInquiryId?: number; size?: number }) {
    return this.client.request<ProductInquiryPageResponse>({
      url: '/api/market-place/v1/product-inquiries',
      method: 'get',
      params,
    });
  }

  async getMyInquiryCount() {
    return this.client.request<number>({
      url: '/api/market-place/v1/product-inquiries/count',
      method: 'get',
    });
  }

  async editInquiry(inquiryId: number, data: ProductInquiryRequest) {
    return this.client.request<ProductInquiryItem>({
      url: `/api/market-place/v1/product-inquiries/${inquiryId}`,
      method: 'put',
      data,
    });
  }

  async deleteInquiry(inquiryId: number) {
    return this.client.request<ProductInquiryItem>({
      url: `/api/market-place/v1/product-inquiries/${inquiryId}`,
      method: 'delete',
    });
  }
}

export const inquiryDataSource = new InquiryDataSourceImpl();
